export default "__VITE_ASSET__DRJVk23S__"